/* ISIS — Upsell panier "Utile avec votre pose" (recommandations auto Shopify).
   Charge les produits liés au 1er article du panier, avec bouton + d'ajout.
   Relancé quand Turbo re-render le mini-cart (MutationObserver).
   2026-07-15 : multi-instances — la page /cart desktop a son propre bloc
   [data-isis-upsell] en plus de celui du drawer (querySelector ne servait que
   le premier du DOM = celui du header, le second restait vide).
   + prix barré compare_at (déjà fourni par recommendations/products.json). */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  var locale = (document.documentElement.lang || 'fr').slice(0, 2);

  function money(cents) {
    try { return (cents / 100).toLocaleString(locale, { style: 'currency', currency: cur }); }
    catch (e) { return (cents / 100).toFixed(2) + ' €'; }
  }

  /* Etat "chargement en cours" garde EN MEMOIRE et non dans un attribut data-*.
     2026-08-07 : avec data-loading="1" sur l'element, le drawer ne montrait JAMAIS son
     cross-sell. Turbo re-render le mini-cart apres un ajout au panier, et la nouvelle box
     naissait avec l'attribut data-loading="1" recopie depuis le DOM courant -> loadBox
     sortait immediatement, definitivement. Symptome : la box du conteneur VISIBLE restait
     vide (loading=1, 0 carte) pendant que celle du conteneur cache se remplissait (4 cartes).
     Comme /cart masque deja son cross-sell en mobile ("le drawer le couvre"), il n'y avait
     plus AUCUN cross-sell nulle part sur mobile. Un WeakSet est indexe sur l'objet DOM :
     une box re-rendue est un nouvel objet, donc elle se recharge normalement. */
  var inflight = new WeakSet();

  async function loadBox(box) {
    if (!box || box.dataset.loaded === '1' || inflight.has(box)) return;
    inflight.add(box);
    try {
      var cart = await fetch(root + 'cart.js').then(function (r) { return r.json(); });
      if (!cart.items || !cart.items.length) { inflight.delete(box); return; }
      var pid = cart.items[0].product_id;
      var inCart = cart.items.map(function (i) { return i.product_id; });
      var url = root + 'recommendations/products.json?product_id=' + pid + '&limit=8&intent=related';
      var data = await fetch(url).then(function (r) { return r.json(); });
      // Le sachet Mix Colors est un CADEAU (jauge 3 sachets ronds) — jamais proposé à l'achat
      var GIFT_HANDLE = 'swarovski-star-collection-mix-colors-small-pack-tooth-gems';
      // Page /cart v3 : carrousel 8 produits avec flèches ; drawer : 4 en grille
      var isCartPage = !!box.closest('.isis-upsell-block--cartpage');
      var recs = (data.products || []).filter(function (p) {
        return inCart.indexOf(p.id) === -1 && p.handle !== GIFT_HANDLE;
      }).slice(0, isCartPage ? 8 : 4);
      if (!recs.length) { inflight.delete(box); return; }
      box.dataset.loaded = '1';

      var nav = (isCartPage && recs.length > 4)
        ? '<span class="isis-up-nav"><button type="button" data-updir="-1" aria-label="Previous">‹</button><button type="button" data-updir="1" aria-label="Next">›</button></span>' : '';
      var html = '<div class="isis-upsell-h">' + (box.dataset.title || '') + nav + '</div>'
        + '<div class="isis-upsell-sub">' + (box.dataset.sub || '') + '</div>'
        + '<div class="isis-upsell-row">';
      recs.forEach(function (p) {
        var img = p.featured_image || (p.images && p.images[0]) || '';
        var imgTag = img ? '<img src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=220" alt="" loading="lazy">' : '';
        var vid = p.variants && p.variants[0] && p.variants[0].id;
        var was = (p.compare_at_price && p.compare_at_price > p.price)
          ? ' <s class="isis-up-was">' + money(p.compare_at_price) + '</s>' : '';
        html += '<div class="isis-up-card">'
          + '<a href="' + p.url + '" class="isis-up-img">' + imgTag + '</a>'
          + '<a href="' + p.url + '" class="isis-up-name">' + p.title + '</a>'
          + '<div class="isis-up-bottom"><span class="isis-up-price">' + money(p.price) + was + '</span>'
          + '<button type="button" class="isis-up-add" data-vid="' + vid + '" aria-label="+">+</button></div>'
          + '</div>';
      });
      html += '</div>';
      box.innerHTML = html;

      var upRow = box.querySelector('.isis-upsell-row');
      box.querySelectorAll('[data-updir]').forEach(function (b) {
        b.addEventListener('click', function () {
          upRow.scrollBy({ left: parseInt(b.dataset.updir, 10) * upRow.clientWidth * 0.8, behavior: 'smooth' });
        });
      });

      box.querySelectorAll('.isis-up-add').forEach(function (btn) {
        btn.addEventListener('click', function () {
          btn.disabled = true; btn.textContent = '✓';
          fetch(root + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: btn.dataset.vid, quantity: 1 })
          }).then(function () { window.location.reload(); });
        });
      });
    } catch (e) { /* silencieux */ }
    inflight.delete(box);
  }

  function loadUpsell() {
    document.querySelectorAll('[data-isis-upsell]').forEach(loadBox);
  }

  function reset() {
    document.querySelectorAll('[data-isis-upsell]').forEach(function (box) {
      if (!box.innerHTML) box.dataset.loaded = '';
    });
  }

  document.addEventListener('DOMContentLoaded', loadUpsell);
  // Turbo re-render le mini-cart après ajout : on relance l'upsell
  var mo = new MutationObserver(function () { reset(); loadUpsell(); });
  function observe() {
    var c = document.querySelector('.cart-container');
    if (c) mo.observe(c, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') observe(); else document.addEventListener('DOMContentLoaded', observe);
})();
